module.exports = __webpack_public_path__ + "static/illus_funciona_3_3x_resized-e11b85b353e90a23e9555e05ad723977.webp";